import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useLanguage } from "@/i18n/LanguageContext";

export function TranslationHistoryCard({ translationHistory }) {
  const { t } = useLanguage();

  if (translationHistory.length === 0) return null;

  return (
    <Card className="mt-6 bento-card" data-testid="history-card">
      <CardHeader className="pb-4">
        <CardTitle className="text-white font-['Outfit']">{t("recentHistory")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 max-h-[300px] overflow-y-auto">
          {translationHistory.map((item, index) => (
            <div key={`${item.timestamp || index}-${item.original?.slice(0, 20)}`} className="bg-zinc-900/50 rounded-lg p-3 border border-zinc-800/50">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs px-2 py-0.5 rounded bg-zinc-800 text-zinc-400">
                  {item.sourceLang && item.targetLang 
                    ? `${item.sourceLang.toUpperCase()} → ${item.targetLang.toUpperCase()}`
                    : "AUTO"
                  }
                </span>
              </div>
              <p className="text-zinc-400 text-sm">{item.original}</p>
              <p className="text-white mt-1">{item.translated}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
